import React from 'react'

const ColorShade = ({ colorCode }) => {
  return (
    <span
      className="shades--color"
      style={{ backgroundColor: colorCode }}
    ></span>
  )
}

export default ColorShade
